import cl from 'classnames';
import { drop } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

const Main = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 32px;

  .main-item {
    .card-news-cover {
      margin-bottom: 12px;
    }
  }

  .other-items {
    display: grid;
    gap: 32px;
    .card-news {
      display: grid;
      grid-template-columns: 100px minmax(0, 1fr);
      gap: 12px;
      .card-news-cover {
        height: 100px;
      }
    }
  }

  ${fromScreen(768)} {
    .other-items {
      .card-news {
        grid-template-columns: 163px minmax(0, 1fr);
        .card-news-cover {
          height: 108px;
        }
      }
    }
  }

  ${fromScreen(1024)} {
    grid-template-columns: minmax(0, 1fr) 416px;
    gap: 32px;
  }
`;

interface HeroListingProps {
  dataSource: any[];
  renderItem: (item: any, index: number) => JSX.Element;
  renderSeparator?: (item: any, index: number) => JSX.Element;
  renderMainItem: (item: any) => JSX.Element;
  className?: string;
}

export const HeroListing = (props: HeroListingProps) => {
  const {
    dataSource,
    renderItem = () => <div />,
    renderMainItem = () => <div />,
    className,
    renderSeparator,
  } = props;
  if (dataSource) {
    const mainContent = dataSource[0];
    const otherContents = drop(dataSource, 1);
    return (
      <Main className={cl('hero-listing', className)}>
        <div className="main-item">{renderMainItem(mainContent)}</div>
        <div className="other-items">
          {otherContents.map((item: any, index) => {
            return (
              <React.Fragment key={item?.id || index}>
                {renderItem(item, index)}
                {renderSeparator &&
                  index < otherContents.length - 1 &&
                  renderSeparator(item, index)}
              </React.Fragment>
            );
          })}
        </div>
      </Main>
    );
  }
  return null;
};
